import { HasId } from '../../../shared/basic-data-management/has-id.interface';

import { MessageCollationneBase } from './message-collationne-base.entity';

export class MessageCollationneTLR extends MessageCollationneBase implements HasId {
	id!: number;

	constructor() {
		super();
	}
}